'use client'
import { useEffect, useState } from 'react'
import SiteLogo from '@/components/atoms/SiteLogo'
import styles from './style.module.scss'

export default function Header() {
  const [fixedHeader, setFixedHeader] = useState(false)
  const changeFixedHeaderHeight = () => {
    setFixedHeader(window.scrollY >= 64)
  }
  useEffect(() => {
    window.addEventListener('scroll', changeFixedHeaderHeight)
    return () => window.removeEventListener('scroll', changeFixedHeaderHeight)
  })
  return (
    <>
      <header
        className={
          styles.header + ' ' + (fixedHeader ? styles.headerFixed : '')
        }
      ></header>
      <SiteLogo fixedHeader={fixedHeader} />
    </>
  )
}
